export default __webpack_public_path__ + "static/media/android-chrome-instructions.435179bc.jpeg";